import script from "./QueriesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueriesList.vue?vue&type=script&lang=ts&setup=true"

import "./QueriesList.vue?vue&type=style&index=0&id=4b34f35b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b34f35b"]])

export default __exports__